import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { asyncScheduler } from 'rxjs';
import { AppState } from '../../core';
import { Point } from '../../core/models/point';
import { PointDoc } from '../../core/schema/point-schema';
import { PointService } from '../../core/services';
import { FesBaseComponent } from '../../shared/components/fes-base.component';

@Component({
  selector: 'app-rxdb-points-edit',
  templateUrl: './rxdb-points-edit.component.html',
  styleUrls: ['./rxdb-points-edit.component.scss']
})
export class RxdbPointsEditComponent extends FesBaseComponent implements OnInit, OnDestroy {
  
  @Input() set point( point : PointDoc ) {
    if ( point ) {
      this._point = point
      this.tmpPoint = { ...point.toJSON() }
    }
  }
  
  _point : PointDoc
  tmpPoint : Point

  errorMsg: string;
  bProcessing: boolean;
  
  get point() { return this._point }
  
  constructor(appState : AppState,protected editModal : BsModalRef,protected pointService:PointService) {
    super(appState);
  }
  ngOnDestroy(): void {
    
  }

  ngOnInit(): void {
  }
  
  onCancel() {
    this.editModal.hide()
  }
  
  async onSave() {
    this.errorMsg = ''
    this.bProcessing = true;
    try {
      if ( this.tmpPoint._id ) {
        await this.pointService.update(this.tmpPoint).toPromise()
      }
      this.editModal.hide()
    } catch ( error ) {
      this.errorMsg = this.pointService.extractErrorMsg(error)
      this.pointService.publishError(error,this)
    } finally {
      asyncScheduler.schedule( () => this.pointService.syncNow() )
      this.bProcessing = false
    }
  }

}
